import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";

export default function Detail_LoadingBar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  const hitRange = item.scale.ranges.find((scale) => scale.isHit);

  return (
    <Row style={{ height: Number(item.height) }}>
      <Col>
        <Row className={"justify-content-center"}>
          <Col xs={"auto"} className="_detail-section-scope-name-header-pdf align-content-center">
            {item.name}
          </Col>
          <Col xs={"auto"}>
            <div className="_main-scope-score-header-pdf-detail">{elementScore}</div>
          </Col>
        </Row>

        <div className="_scope-detail-scope-loading-container">
          <div
            style={{
              paddingTop: "12px",
            }}
          >
            <ProgressBar
              variant={isSub ? "sub-scope" : "main-scope"}
              label={`%${elementScore} ${hitRange.text}`}
              now={elementScore}
            />
          </div>
          <Row>
            <Col xs="5">
              <div className="_scale-detail-text-pdf" dangerouslySetInnerHTML={{ __html: item.lowSideText }} />
            </Col>
            <Col xs={{ offset: 2, span: 5 }}>
              <div className="_scale-detail-text-pdf" dangerouslySetInnerHTML={{ __html: item.highSideText }} />
            </Col>
          </Row>
          {item.generalInformationText?.length > 2 && (
            <div className="_scale-detail-text" dangerouslySetInnerHTML={{ __html: item.generalInformationText }} />
          )}
        </div>
      </Col>
    </Row>
  );
}
